var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-panel',{scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('h1',[_vm._v("Most Played")])]},proxy:true},{key:"body",fn:function(){return _vm._l((_vm.games),function(item,index){return _c('app-game',{key:index,attrs:{"showPlaysText":true,"item":item}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }